export default __webpack_public_path__ + "static/to-down-en-719096c1430efdc4197fc26111b66d96.svg";